import styled from 'styled-components';
import { Button, getButtonHeight, LoaderWrapper } from '../Button';

export const IconButtonElement = styled(Button)`
    padding: 0;
    width: ${getButtonHeight}px;

    & > *:not(:last-child):not(${LoaderWrapper}) {
        margin-right: 0;
    }
`;
